export default __webpack_public_path__ + "static/media/Brochure_te.e379fe69.pdf";